/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState, useEffect} from 'react';
import SearchBox from "../../components/SearchBox";
import PageBox from "../../layouts/pageBox";
import Loader from "../../elements/loader";
import {useForm} from "react-hook-form";
import ModelPartsForm from "../../components/ModelPartsForm";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import SEO from "../../components/SEO";


const Models = () => {

    const [makes, setMakes] = useState({isLoading: true, data: [], error: false});
    const [models, setModels] = useState({isLoading: true, data: [], error: false});

    const [searchValue, setSearchValue] = useState("");
    const [activeRow, setActiveRow] =  useState({makeSlug: '', rowKey: false});

    const [triggerUpdate, setTriggerUpdate] = useState(true);

    const params = useParams();
    const { t, i18n } = useTranslation();
    const axiosJWT = useAxiosJTW();

    const { control, register, handleSubmit, watch, formState: { errors }, trigger, clearErrors } = useForm({
        mode: "onChange"
    });

    const data= {
        title: t('parts.listingTitle'),
        subtitle: t('parts.listingSubtitle'),
    };

    const getMakes = (signal) => {
        setMakes({...makes, isLoading: true});
        axiosJWT.post('api/getallmakes', {"has_ads": "1"}, {signal}).then( (response) => {
            if(response.status === 200){
                setMakes({...makes, data: response.data.makes|| [], isLoading: false});

            }
        } ).catch((error) => {
            console.log(error);
        });
    }

    const getModelByMake = (data) => {
        setModels({...models, isLoading: true});
        axiosJWT.post('api/getmodelsbymake', { make: data }).then( (response) => {
            if(response.status === 200){
                setModels({...models, data: response.data.models|| [], isLoading: false});
                setTriggerUpdate(true);
            }
        } ).catch((error) => {
            console.log(error);
        });
    }

    useEffect(() => {
        const controller = new AbortController();
        const signal= controller.signal;

        getMakes(signal);

        return () => {controller.abort();}
    }, [params]);

    useEffect(() => {
        if(!makes.isLoading){

            const queryParameters = new URLSearchParams(window.location.search);
            const _make = queryParameters.get("make");
            if( _make != null ){
                const _row = findActiveRowByMake( makes, _make);
                onSelectMake(_row, _make);
                const element = document.getElementById(`row__${_row}`);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth',  block: 'center' });
                }
            }

        }
    }, [makes]);

    const onSelectMake = (key, slug) => {
        setActiveRow({makeSlug: slug, rowKey: key})
        setTriggerUpdate(false);

        getModelByMake(slug);
    }

    const filterNames = ({ title }) => {
        return title.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1;
    };

    const findActiveRowByMake = (makes, make) =>{
        let active_row = '';
        Object.keys(makes.data).map((key, index) => {
            makes.data[key].map((_make, i) => {
                if( _make.slug ==  make){
                    active_row = key;
                }
            })
        })
        return active_row;
    }


    return (
        <>
            <SEO
                title={t('meta_title.models' )}
                description={t('meta_description.models') }
            />
            <PageBox data={data}>
                <div className='page-header'>
                    <SearchBox onSearch={setSearchValue} value={searchValue}/>
                </div>
                <div className='page-body'>
                    <div className='SearchByCar' >

                        {makes.isLoading ? (
                            <div style={{ paddingTop: '30px', textAlign : 'center', margin: '0 auto' }}><Loader/></div>
                        ) : (
                            Object.keys(makes.data).map((key, index) => {
                                return (
                                    <div id={`row__${key}`} className={`SearchByCar__item ${makes.data[key].filter(filterNames).length > 0 ? "" : "SearchByCar__item--hide"} `} key={index}>
                                        <div className='SearchByCar__letter'>{key}</div>
                                        <div className='SearchByCar__results'>
                                            <div className='SearchByCar__btns row extra-small-gutters'>
                                                { makes.data[key].filter(filterNames).map( (make, index2) => (
                                                    <div className="col-auto" key={index2}><button className={`btn SearchByCar__result ${parseInt(make.count) == 0 ? "SearchByCar__result--empty" : ""} ${make.slug == activeRow.makeSlug ? "active" : ""} `} onClick={ () => {onSelectMake(key, make.slug)} } >{make.title}</button></div>
                                                ) ) }
                                            </div>
                                            { triggerUpdate && key == activeRow.rowKey && <ModelPartsForm models={models.data} modelLoading={models.isLoading} selectedMake={activeRow.makeSlug}/>}
                                            {/*{ key == activeRow.rowKey && <ModelPartsForm models={models.data} modelLoading={models.isLoading} selectedMake={activeRow.makeSlug}/>}*/}
                                        </div>
                                    </div>
                                );
                            })

                        )}

                        {/*<div className='SearchByCar__item SearchByCar__item--empty' >*/}
                        {/*    <div className='SearchByCar__letter'>{key}</div>*/}
                        {/*    <div className='SearchByCar__results'></div>*/}
                        {/*</div>*/}

                    </div>
                </div>
            </PageBox>
        </>
    );
};

export default Models;
